'use strict';

const CODE_LENGTH = 6;

const _state = {
    initLoginButtonText: '',
    mfaVerifyButtonText: '',
    mfaSubmitting: false,
    mfaCooldownTimer: null,
};

export function enableLoginButton(){
    $('#btnSignIn').text(_state.initLoginButtonText);
}

export function init (){

    _state.initLoginButtonText = $('#btnSignIn').text();

    // Login Non SSO
    const loginFormSelector = '#loginForm.js-non-sso';
    const $nonSSOLoginForm = $(loginFormSelector);

    $nonSSOLoginForm.bind('submit', (event) =>{
        event.preventDefault();

        if ($('#btnSignIn').text() != 'Processing...'){
            if ($nonSSOLoginForm.valid()){
                $('#btnSignIn').text('Processing...');
                $('#lastUser').val($nonSSOLoginForm.find("[name='un']").val());
                saveForm('loginForm');
            }
        }
    });

    //Username Changed
    $nonSSOLoginForm.find("[name='un']").bind('keyup change', function(){

        var currentuser = $(this).val(),
            lastUser = $('#lastUser').val();

        if (lastUser != '' && currentuser != lastUser){
            $('#loginRemaining').customHide();
        } else {
            $('#loginRemaining').customShow();
        }

    });

    const cancelSignInSelector = '#btnCancelSignIn';
    $(cancelSignInSelector).bind('click', (event) =>{
        event.preventDefault();
        redirect_refresh('','index.cfm','');
    });

    $nonSSOLoginForm.validate({
        rules: {
            un: {
                required: true,
            },
            pw: {
                required: true,
            },
        },
        messages: {
            un: {
                required: 'Please enter a username',
            },
            pw: {
                required: 'Please enter a password',
            },
        },
    });
}

// Verification code step. Only wires itself up when the page is rendering it.
export function initMFA (){

    const $verifyForm = $('#mfaVerify.js-mfa-verify');

    if ($verifyForm.length === 0){
        return;
    }

    const $code = $('#mfaCode');
    const $status = $('#mfaStatus');
    const $verifyButton = $('#btnVerifyCode');
    const $resendLink = $('#btnResendCode');

    _state.mfaVerifyButtonText = $verifyButton.text();
    _state.mfaSubmitting = false;

    // saveForm returns this flag as the string 'true' or 'false', so the
    // string 'false' is truthy and cannot be tested directly.
    function savedOK(result){
        return String(result.SAVED).toLowerCase() === 'true';
    }

    function showStatus(message, isError){
        $status.html(message || '')
            .toggleClass('is-error', isError === true)
            .toggleClass('is-success', isError !== true && !!message);
    }

    // jQuery 1.5.2 has no .prop() - see .cursor/rules/js-library-upgrades.mdc
    function releaseVerifyButton(){
        _state.mfaSubmitting = false;
        $verifyButton.removeAttr('disabled').text(_state.mfaVerifyButtonText);
    }

    function focusCode(){
        $code.trigger('focus');
    }

    // Only digits, and never more than the code length, so a pasted
    // "428 195" becomes "428195" rather than being truncated.
    function normaliseCode(){
        const cleaned = ($code.val() || '').replace(/\D/g, '').slice(0, CODE_LENGTH);
        if (cleaned !== $code.val()){
            $code.val(cleaned);
        }
        return cleaned;
    }

    function stopCooldown(){
        if (_state.mfaCooldownTimer){
            clearInterval(_state.mfaCooldownTimer);
            _state.mfaCooldownTimer = null;
        }
    }

    function startCooldown(seconds){
        stopCooldown();

        const label = $resendLink.data('resend-label') || 'Resend code';
        let remaining = parseInt(seconds, 10);

        if (isNaN(remaining) || remaining <= 0){
            $resendLink.text(label).removeClass('is-disabled');
            return;
        }

        // Cosmetic only. The server enforces the interval between sends.
        function tick(){
            if (remaining <= 0){
                stopCooldown();
                $resendLink.text(label).removeClass('is-disabled');
                return;
            }
            $resendLink.text(label + ' (' + remaining + ')').addClass('is-disabled');
            remaining -= 1;
        }

        tick();
        _state.mfaCooldownTimer = setInterval(tick, 1000);
    }

    async function handleRestart(result){
        await EQLAPP.ALERT.showAlert({
            title: 'equisoft Live',
            body: result.RESULTMSG,
            callback: function () {},
        });

        window.location = (result.REDIRECTLOCATION && result.REDIRECTLOCATION.length > 0)
            ? result.REDIRECTLOCATION
            : '?page=login';
    }

    async function handleVerifyResult(saveResult){

        const result = ColdFusion.JSON.decode(saveResult);

        releaseVerifyButton();

        if (savedOK(result)){
            // Authenticated. Same redirect handling as a login without MFA.
            redirect_refresh(result, '', '');
            return;
        }

        if (result.RESTART){
            await handleRestart(result);
            return;
        }

        showStatus(result.RESULTMSG, true);
        $code.val('');
        focusCode();
    }

    async function handleResendResult(saveResult){

        const result = ColdFusion.JSON.decode(saveResult);

        if (result.RESTART){
            await handleRestart(result);
            return;
        }

        showStatus(result.RESULTMSG, !savedOK(result));
        startCooldown(result.RESENDINSECONDS);

        if (savedOK(result)){
            $code.val('');
        }

        focusCode();
    }

    function submitVerify(){
        if (_state.mfaSubmitting){
            return;
        }

        if (normaliseCode().length !== CODE_LENGTH){
            showStatus(
                'Please enter the ' + CODE_LENGTH + '-digit verification code from your email.',
                true,
            );
            focusCode();
            return;
        }

        _state.mfaSubmitting = true;
        $verifyButton.attr('disabled', 'disabled').text('Processing...');
        showStatus('', false);

        saveForm('mfaVerify', false, handleVerifyResult);
    }

    $code.bind('input', () => {
        const cleaned = normaliseCode();

        if (cleaned.length === CODE_LENGTH){
            submitVerify();
        }
    });

    $verifyForm.bind('submit', (event) => {
        event.preventDefault();
        submitVerify();
    });

    $resendLink.bind('click', function(event){
        event.preventDefault();

        if ($(this).hasClass('is-disabled')){
            return;
        }

        showStatus('', false);
        saveForm('mfaResend', false, handleResendResult);
    });

    startCooldown($resendLink.data('resend-in'));

    // autofocus is unreliable for content rendered into an existing page
    focusCode();
}
